import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
    state: () => ({
        user: JSON.parse(localStorage.user || `{
            "school":"school"
        }`),
        Header: JSON.parse(localStorage.Header || "{}"),
        out_url: "",
        LoginData: JSON.parse(localStorage.LoginData || "{}"),
    }),
    getters: {},
    actions: {},
})
